import { create } from 'zustand'

type FormType = 'login' | 'signup' | false
interface LoginFormState {
  formType: FormType
  setFormType: (formType: FormType) => void
}

export const useLoginStore = create<LoginFormState>(set => ({
  formType: false,
  setFormType: (formType: FormType) => set({ formType })
}))
